(function () {
  if (window.__surfaceHeroInitialized) return;
  window.__surfaceHeroInitialized = true;

  function hidePoster(video) {
    var posterId = video.getAttribute('data-hero-poster-id');
    if (!posterId) return;

    var poster = document.getElementById(posterId);
    if (poster) {
      poster.classList.add('hero-slide__video-poster--hidden');
    }
  }

  document.addEventListener('playing', function (event) {
    if (event.target.matches('[data-hero-video]')) {
      hidePoster(event.target);
    }
  }, true);


})();
